import { categories } from "@/mocks/mangaData";

export default function Categories() {
  return (
    <section id="category" className="py-12 md:py-20 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl mb-8 md:mb-12">
          <span className="inline-flex items-center gap-1.5 text-accent-600 text-sm font-medium">
            <i className="ri-grid-fill"></i>
            分类推荐
          </span>
          <h2 className="mt-2 font-display text-2xl md:text-4xl text-foreground-950">
            按类型找你的本命
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            不管你是热血党、纯爱战士还是烧脑控，总有一个分类藏着你的下一部本命漫。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((c) => (
            <a
              key={c.id}
              href="#recommend"
              className="group relative overflow-hidden rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300 transition-colors"
            >
              <div className="relative h-40 md:h-44 overflow-hidden">
                <img
                  src={c.image}
                  alt={`${c.name}分类本命推荐`}
                  title={`${c.name} - 131漫画网分类推荐`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2 text-background-50">
                  <span className="w-9 h-9 rounded-lg bg-primary-500/90 flex items-center justify-center">
                    <i className={`${c.icon} text-base`}></i>
                  </span>
                  <span className="font-display text-lg">{c.name}</span>
                </div>
              </div>
              <div className="p-4">
                <p className="text-sm text-foreground-700 leading-relaxed">{c.desc}</p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{c.count}</span>
                  <span className="inline-flex items-center gap-1 text-sm text-primary-600 whitespace-nowrap">
                    去看看
                    <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}